import { render, staticRenderFns } from "./PostulantExistingUser.vue?vue&type=template&id=6ac38fe8&scoped=true&"
import script from "./PostulantExistingUser.vue?vue&type=script&lang=js&"
export * from "./PostulantExistingUser.vue?vue&type=script&lang=js&"
import style0 from "./PostulantExistingUser.vue?vue&type=style&index=0&id=6ac38fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac38fe8",
  null
  
)

export default component.exports